import { Box, Tooltip } from '@mui/material';

import { TextLink } from '@/components/shared/textLink';

interface DbLinkProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dataLocation: any;
  resourceId: string;
}

function formatDbPath(dataLocation: DbLinkProps['dataLocation']): string {
  const parts: string[] = [];
  if (dataLocation?.database) parts.push(`[${dataLocation.database}]`);
  if (dataLocation?.table) parts.push(`[${dataLocation.table}]`);
  if (dataLocation?.column) parts.push(`[${dataLocation.column}]`);
  return parts.join('.');
}

export const DBLink = (props: DbLinkProps) => {
  const { dataLocation, resourceId } = props;

  if (dataLocation?.sql) {
    // Truncate SQL for display, show full in tooltip
    const sql = String(dataLocation.sql);
    const truncatedSql = sql.length > 60 ? `${sql.slice(0, 60)}...` : sql;
    // Example DB Explorer link, adjust path/query as needed
    const dbExplorerUrl = `/db/${resourceId}?query=${encodeURIComponent(sql)}`;
    return (
      <Tooltip title={sql}>
        <TextLink href={dbExplorerUrl}>{truncatedSql}</TextLink>
      </Tooltip>
    );
  }
  if (dataLocation?.database || dataLocation?.table || dataLocation?.column) {
    const fullPath = formatDbPath(dataLocation);
    return (
      <Tooltip title={fullPath}>
        <Box
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {fullPath}
        </Box>
      </Tooltip>
    );
  }
};
